import {styled} from "@mui/material/styles";
import React, {useEffect} from "react";
import {useTheme} from "../../../contexts/theme";
import Box from "@mui/material/Box";
import {Collapse, FormControlLabel, IconButton, SelectChangeEvent, Typography} from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import Grid from "@mui/material/Grid";
import StyledCheckBox from "../StyledCheckbox/StyledCheckBox";
import StyledSlider from "../StyledSlider/StyledSlider";
import CustomDivider from "../CustomDivider/CustomDivider";


interface StyledCollapseProps {
    children: React.ReactNode;
    onClose?: () => void;
    onOpen?: () => void;
    title: string;
    paddingLeft?: string;
    action?: React.ReactNode;
    initialValue?: boolean;
    icon?: JSX.Element;
}

const StyledCollapse: React.FC<StyledCollapseProps> = ({initialValue, children, onOpen = () => {}, onClose = () => {}, title, paddingLeft, action, icon}) => {

    const [open, setOpen] = React.useState(false);
    const theme = useTheme();

    useEffect(() => {
        if(initialValue !== undefined){
            setOpen(initialValue);
        }
    }, []);

    return (
        <Box sx={{paddingTop: theme.spacing.sm, paddingBottom: theme.spacing.sm, paddingLeft: paddingLeft ? paddingLeft :theme.spacing.md, paddingRight: theme.spacing.md}}>
            <Box display={'flex'} alignItems={'center'}>
                {icon && <Typography sx={{color: theme.palette.white, paddingRight: theme.spacing.sm}}>{icon}</Typography>}
                <Typography sx={{color: theme.palette.white}}>{title}</Typography>

                <CustomDivider />

                {action && (
                    <Box ml={theme.spacing.sm} display="flex" alignItems="center">
                        {action}
                    </Box>
                )}



                {!open && <IconButton onClick={() => {setOpen(true);onOpen();}}><ArrowDropDownIcon sx={{color: theme.palette.white}}></ArrowDropDownIcon></IconButton>}
                {open && <IconButton onClick={() => {setOpen(false);onClose();}}><ArrowDropUpIcon sx={{color: theme.palette.white}}></ArrowDropUpIcon></IconButton>}
            </Box>
            <Collapse in={open}>
                {children}
            </Collapse>
        </Box>
    )
}

export default StyledCollapse;